_getNextEventHandler